import { render, staticRenderFns } from "./SiteHome.vue?vue&type=template&id=3b6ee636&scoped=true"
import script from "./SiteHome.vue?vue&type=script&lang=js"
export * from "./SiteHome.vue?vue&type=script&lang=js"
import style0 from "./SiteHome.vue?vue&type=style&index=0&id=3b6ee636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ee636",
  null
  
)

export default component.exports